// custom-input-toggle.js
import React from "react"
import PropTypes from "prop-types"
import { Button, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  label: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.only("xs")]: {
      justifyContent: "center", // Center label for mobile view
      marginBottom: theme.spacing(1),
    },
  },
  toggleContainer: {
    display: "flex",
    borderRadius: "10px",
    overflow: "hidden",
    border: `1px solid #2D303A`,
    width: "fit-content", // Adjust width to fit content
    [theme.breakpoints.only("xs")]: {
      margin: "0 auto", // Center container for mobile view
    },
  },
  button: {
    padding: theme.spacing(1, 2), // Adjust padding for a more compact look
    "&.active": {
      backgroundColor: "#2D303A",
      color: "#fff",
    },
    "&.inactive": {
      backgroundColor: "#fff",
      color: "#2D303A",
    },
  },
  asterisk: {
    color: "red",
    marginRight: theme.spacing(0.5),
  },
}))

const CustomInputToggle = ({
  label = "",
  labelYes = "Yes",
  labelNo = "No",
  value,
  onChange,
  required = false,
}) => {
  const classes = useStyles()

  const handleToggle = (value) => {
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <Grid
      container
      spacing={2}
      className={classes.container}
      alignItems="center"
    >
      <Grid item xs={12} sm={3} className={classes.label}>
        {required && <span className={classes.asterisk}>*</span>}
        <Typography variant="body1">{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <div className={classes.toggleContainer}>
          <Button
            className={`${classes.button} ${value ? "active" : "inactive"}`}
            onClick={() => handleToggle(true)}
          >
            {labelYes}
          </Button>
          <Button
            className={`${classes.button} ${!value ? "active" : "inactive"}`}
            onClick={() => handleToggle(false)}
          >
            {labelNo}
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}

CustomInputToggle.propTypes = {
  label: PropTypes.string.isRequired,
  labelYes: PropTypes.string,
  labelNo: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
}

export default CustomInputToggle
